import { InitFeatureParams } from '../types'

import { getRoutes } from './routes'

/**
 * 初始化 Home
 *
 * @param param0 - 参数
 * @param param0.addRoutes - 添加路由
 */
export const initHome = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes())
}
